import React  from 'react';
import { getString } from '../../../app-content';
import bannerImage from '../../../assets/bannerImage.png';
import elevateImage from '../../../assets/elevate.png';
import { Button, Image } from '@nackle/paper';

export default function LinkView( props ) {
    const { appCodeSignin, formattedIntegration } = props;

    const TeamsView = () => {
        return ( 
            <div>
                <div style={ { display: 'flex', justifyContent: 'center', paddingTop: '36px', paddingBottom: '31px' } }>
                    <Image preview={ false } src={ formattedIntegration === 'Teams' ? elevateImage : bannerImage } alt=''/>
                </div>
                <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } }>
                    <div style={ { fontSize: '14px', paddingBottom: '26px' } }>
                        { getString( formattedIntegration === 'Teams' ? 'teams.webView.connectAccountMessage.elevate' : 
                            'teams.webView.connectAccountMessage', { integration: formattedIntegration } ) }</div>
                    <Button
                        onClick={ ( e ) => {
                            appCodeSignin();
                        } }
                    >
                        { getString( formattedIntegration === 'Teams' ? 'teams.webView.connectAccountButton.elevate' : 'teams.webView.connectAccountButton' ) }
                    </Button>
                </div>
            </div>
        );
    };

    const WorkplaceView = () => {
        return ( 
            <div>
                <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingTop: '66px' } }>
                    <div style={ { fontSize: '14px', paddingBottom: '8px' } }>{ getString( 'teams.webView.workplace.get-started' ) }</div>
                    <div style={ { fontSize: '18px', fontWeight: 'bold', paddingBottom: '24px' } }>{ getString( 'teams.webView.workplace.connect', { integration: formattedIntegration } ) }</div>
                </div>
                <div style={ { display: 'flex', justifyContent: 'center', paddingTop: '36px', paddingBottom: '31px' } }>
                    <Image preview={ false } src={ bannerImage } alt=''/>
                </div>
                <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingLeft: '40px', paddingRight: '40px' } }>
                    <div style={ { fontSize: '14px', textAlign: 'center', paddingBottom: '26px' } }>{ getString( 'teams.webView.connectAccountMessage', { integration: formattedIntegration } ) }</div>
                    <Button
                        className='primary-button-background'
                        style={ { color: 'white' } }
                        onClick={ ( e ) => {
                            appCodeSignin();
                        } }
                    >
                        { getString( 'teams.webView.workplace.connect' ) }
                    </Button>
                </div>
            </div>
        );
    };

    return ( 
        formattedIntegration === 'Workplace' ? <WorkplaceView /> : <TeamsView />
    );
}
